import { CircularProgress } from "@mui/material";

export const Circular = () => (
  <div style={{ padding: "24px", backgroundColor: "#424242" }}>
    <CircularProgress size={75} />
  </div>
);
